declare global {
  interface Window {
    SPA_RUNTIME_CONFIGURATION: {
      domain: string;
      portalBackendRootUrl: string;
      portalCloudRenderingSessionManagementRootUrl: string;
      portalOAuth2ClientId: string;
      googleMapsApiKey: string;
      desktopClientOAuth2ClientId: string;
      gtmId?: string;
      sentryDSN?: string;
      supportUrl?: string;
      showClientApplicationStoreInstallationInstructions?: boolean;
    };
  }
}

export const domain = window.SPA_RUNTIME_CONFIGURATION.domain;

// In dev, backend calls are proxied through the Vite dev server (see
// vite.config.ts). Point the SPA at its own origin so responses come back
// through the proxy — this is what lets the browser persist backend
// `Set-Cookie`s (session, csrftoken, …) on the dev origin instead of the
// unreachable real backend host.
export const portalBackendUrl = import.meta.env.DEV
  ? window.location.origin
  : window.SPA_RUNTIME_CONFIGURATION.portalBackendRootUrl;

export const portalOAuth2ClientId =
  window.SPA_RUNTIME_CONFIGURATION.portalOAuth2ClientId;

export const cloudRenderingSessionManagementServiceUrl =
  window.SPA_RUNTIME_CONFIGURATION.portalCloudRenderingSessionManagementRootUrl;

export const googleMapsApiKey =
  window.SPA_RUNTIME_CONFIGURATION.googleMapsApiKey;

export const desktopClientOAuth2ClientId =
  window.SPA_RUNTIME_CONFIGURATION.desktopClientOAuth2ClientId;

export const googleTagManagerId = window.SPA_RUNTIME_CONFIGURATION.gtmId;

export const sentryDSN = window.SPA_RUNTIME_CONFIGURATION.sentryDSN;

export const showClientApplicationStoreInstallationInstructions =
  window.SPA_RUNTIME_CONFIGURATION
    .showClientApplicationStoreInstallationInstructions ?? false;

export default window.SPA_RUNTIME_CONFIGURATION;

export const defaultStreamingServerExpirationTimespan = "00:30:00";
